var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.editPostId !== null
        ? _c("input-post", {
            staticClass: "col",
            attrs: { skipChannelSelection: "", editPost: _vm.editPostId },
            on: { cancel: _vm.cancelEdit }
          })
        : _c(
            "div",
            [
              _c(_vm.getListItemType, {
                tag: "component",
                attrs: {
                  type: _vm.type,
                  title: _vm.title,
                  discount: _vm.discount,
                  price: _vm.price,
                  image: _vm.image,
                  selectable: _vm.selectable,
                  editable: _vm.editable,
                  uid: _vm.uid,
                  selected: _vm.postSelected,
                  imported: _vm.imported
                },
                on: { selected: _vm.selectBox, deletePost: _vm.deletePost }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74957b6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74957b6c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/service/postList/ItemPost.vue
// module id = null
// module chunks = 